import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusfilter'
})
export class StatusfilterPipe implements PipeTransform {
  transform(items: any[], status: string): any[] {
    if (!items) {
      return [];
    }
    if (status === 'All') {
      return items;
    }
    return items.filter(item => item.status === status);
  }


}
